// IMPORT REACT
import React from 'react';
import Axios from 'axios';

// IMPORT COMPONENTS
import YAText from '../../Text';
import YARow from '../../Grid/Row';
import YAColumn from '../../Grid/Column';
import YAButton from '../../Form/Button';
import YASubmit from '../../Form/Submit';
import YAIcon from '../../Icon';
import YAInput from '../../Form/Input';
import YAAlert from '../../Alert';

// IMPORT STYLES
import { SC_Folder, SC_IconContainer } from '../styles';


class YAFolderAdd extends React.Component {

	constructor(props) {
		super();
		this.state = {
			formError: null,
			formSuccess: null,
			allPermissions: [],
			allCategories: [],
		};
	}

	componentDidMount() {

		this.getCategories('en').then(data => {
			this.setState({
				allCategories: data,
			});
		});

		this.getPermissions('en').then(data => {
			this.setState({
				allPermissions: data,
			});
		});

	}

	addNewCategory(e) {
		e.preventDefault();
		let url = '/wp-json/wp/v2/weemarkable/category-manage/';
		let form = document.getElementById("add_category_form");
		let data = new FormData(form);
		return Axios({
			method: 'post',
			url: url,
			data: data,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	getPermissions(lang) {
		let url = '/wp-json/wp/v2/weemarkable/permissions/';
		url += '?lang=';
		url += lang;
		return Axios({
			method: 'get',
			url: url,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	getCategories(lang) {
		let url = '/wp-json/wp/v2/weemarkable/categories/';
		url += '?lang=';
		url += lang;
		url += '&parent=any';
		return Axios({
			method: 'get',
			url: url,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	render() {
		let formError = this.state.formError;
		let allCategories = this.state.allCategories;
		let allPermissions = this.state.allPermissions;
		let cancelCallbackFunction = this.props.cancelCallbackFunction;
		let selectedCategory = this.props.selectedCategory;

		let categoriesOptions = allCategories && allCategories.length ? allCategories.map((category) => {
			return ({
				id: category.slug,
				label: category.ancestors + ' ' + category.name_english,
				value: category.term_id,
			});
		}) : null;

		let permissionsOptions = allPermissions && allPermissions.length ? allPermissions.map((permission) => {
			return ({
				id: 'add_' + permission.meta_key,
				value: permission.value,
				label: permission.meta_label
			});
		}) : null;

		return (
			<SC_Folder>
				<YARow center="vertical">
					<YAColumn size="col-auto" autoWidth>
						<SC_IconContainer>
							<YAIcon icon="folder" height="100px" fill="ymcaOrangeDark" altFill="ymcaOrangeBright" />
						</SC_IconContainer>
					</YAColumn>
					<YAColumn autoWidth>
						<YAText bootstrap="font-weight-bold text-left text-primary">
							Add New Folder
						</YAText>
					</YAColumn>
					<YAColumn size="col-auto" autoWidth>
						<YAButton size="sm" color="dark" onClick={() => { cancelCallbackFunction() }}>
							Cancel
						</YAButton>
					</YAColumn>
				</YARow>

				<form id="add_category_form" onSubmit={(e) => {
					this.addNewCategory(e).then(data => {
						if (data.error) {
							this.setState({
								formSuccess: null,
								formError: data.error
							})
						} else if (data.success) {
							this.setState({
								formError: null
							})
							cancelCallbackFunction(data.success)
						}
					});
				}}>
					{formError &&
						<YAAlert color="danger">
							{formError}
						</YAAlert>}

					<YAInput type="text" id="add_name_en" label="Folder Name - English" />
					<YAInput type="text" id="add_name_fr" label="Folder Name - French" />
					<YAInput type="select" id="add_parent" label="Parent Folder" value={selectedCategory} options={categoriesOptions} />
					<YAInput type="checkbox" label="Permissions" options={permissionsOptions} />

					<YASubmit color="success" value="Save" />

					<br />	<br />
				</form>
			</SC_Folder>
		)
	}
}
export default YAFolderAdd;